<div class="full-height layout-column overflow-hidden planning-draft-job-changes-list">

  <div class="summary-bar layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-600">{{ totalElements }} <span translate>Total New Updates</span></span>
    @if (unavailableCount) {
      <span class="summary-divider"></span>
      <bringoz-icon iconName="info-outline" classSize="sm" class="warning-icon"></bringoz-icon>
      <span class="br-body-2 font-weight-600 unavailable-count">{{ unavailableCount }} <span translate>Unavailable Updates</span></span>
    }
  </div>

  <div class="filters-bar layout-row layout-wrap layout-align-start-center gap-10 padding-left-10 padding-right-10">

    <app-bringoz-search-input [query]="query"
                              placeholder="Search"
                              (queryChangeEvent)="onQueryChange($event)">
    </app-bringoz-search-input>

    <div class="filter-pill layout-row layout-align-start-center">
      <bringoz-icon iconName="rotate" classSize="sm" class="margin-right-5"></bringoz-icon>
      <ng-select class="pill-select"
                 [items]="changeTypeOptions"
                 [multiple]="true"
                 placeholder="{{ 'Update Type' | translate }}"
                 [(ngModel)]="filters.changeTypes"
                 (change)="onFiltersChange()">
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          {{ 'PLANNING_DRAFT_JOB_CHANGES_TYPES.' + item | translate }}
        </ng-template>
      </ng-select>
    </div>

    <div class="filter-pill layout-row layout-align-start-center">
      <bringoz-icon iconName="info-outline" classSize="sm" class="margin-right-5"></bringoz-icon>
      <ng-select class="pill-select"
                 [items]="reasonOptions"
                 [multiple]="true"
                 placeholder="{{ 'Reason' | translate }}"
                 [(ngModel)]="filters.reasons"
                 (change)="onFiltersChange()">
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          {{ 'PLANNING_DRAFT_JOB_CHANGES_REASONS.' + item | translate }}
        </ng-template>
      </ng-select>
    </div>

    <div class="filter-pill layout-row layout-align-start-center">
      <bringoz-icon iconName="package" classSize="sm" class="margin-right-5"></bringoz-icon>
      <ng-select class="pill-select"
                 [items]="statusOptions"
                 [multiple]="true"
                 placeholder="{{ 'Status' | translate }}"
                 [(ngModel)]="filters.statuses"
                 (change)="onFiltersChange()">
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          {{ 'PLANNING_DRAFT_JOB_CHANGES_STATUSES.' + item | translate }}
        </ng-template>
      </ng-select>
    </div>

    <span class="flex"></span>

    <div class="layout-row layout-align-start-center show-unavailable-toggle">
      <bringoz-switch classSize="sm"
                      label="{{ 'Show Unavailable Updates' | translate }}"
                      name="showUnavailable"
                      [checked]="showUnavailable"
                      (onChange)="onToggleShowUnavailable($event)">
      </bringoz-switch>
    </div>
  </div>

  <div class="flex layout-column bringoz-table overflow-hidden">

    <div class="tr text-uppercase layout-row layout-align-start-center">
      <div class="th flex-5"><app-bringoz-checkbox [isDisabled]="!selectableIds.length" [isChecked]="isAllSelected" [isIndeterminate]="isIndeterminate" (clickEvent)="onToggleSelectAll()"></app-bringoz-checkbox></div>
      <div class="th flex-25" translate>Job</div>
      <div class="th flex-20" translate>Changed</div>
      <div class="th flex-15" translate>Route</div>
      <div class="th flex-25" translate>Reason</div>
      <div class="th flex-10"></div>
    </div>

    @if (selectAllMatching) {
      <div class="select-all-banner layout-row layout-align-center-center">
        <span class="br-body-2 font-weight-600">{{ 'PLANNING_DRAFT_JOB_CHANGES_ALL_MATCHING_SELECTED' | translate:{count: totalElements} }}</span>
        <bringoz-button type="tertiary" size="fit" (onClick)="onClearSelection()">
          <span translate>Clear Selected</span>
        </bringoz-button>
      </div>
    } @else if (selectedIds.length) {
      <div class="select-all-banner layout-row layout-align-center-center">
        <span class="br-body-2 font-weight-600">{{ 'PLANNING_DRAFT_JOB_CHANGES_SELECTED_COUNT' | translate:{count: selectedIds.length} }}</span>
        <bringoz-button type="tertiary" size="fit" (onClick)="onClearSelection()">
          <span translate>Clear Selected</span>
        </bringoz-button>
      </div>
    }

    <div #rowsContainer class="full-height flex rows-container overflow-auto" (scroll)="onScroll()">
      @for (change of changes; track change.id) {
        <app-planning-draft-job-change-row [change]="change"
                                           [isSelected]="selectAllMatching || selectedIds.includes(change.id)"
                                           [isSelectionLocked]="selectAllMatching"
                                           [isExpanded]="expandedId === change.id"
                                           (onToggleSelect)="onToggleSelect($event)"
                                           (onToggleExpand)="onToggleExpand($event)">
        </app-planning-draft-job-change-row>
      }

      @if (!loading && !changes.length) {
        <app-empty-state src="assets/images/empty_state/empty_state_calendar.png"
                         text="{{ 'PLANNING_DRAFT_JOB_CHANGES_EMPTY_STATE' | translate }}">
        </app-empty-state>
      }
    </div>

    <loader [isDisplayLoader]="loading"></loader>
  </div>

</div>
